import { NotAuthorized } from "_shared/_errors/_views/not-authorized";
import CompanyBookmarks from "marketplace/bookmarks/company-bookmarks/_views/company-bookmarks-table";
import IndividualBookmarks from "marketplace/bookmarks/individual-bookmarks/_views/individual-bookmarks-table";
import TeamBookmarks from "marketplace/bookmarks/team-bookmarks/_views/team-bookmarks-table";
import { getSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import useSessionPermissionsLoadState from "permissions/session/use-session-permissions-load-state";
import { useSelector } from "react-redux";
import { useLoaderData } from "react-router";
import { PageTab } from "./bookmarks-page-tabs";

export default function Bookmarks() {
  const route = useLoaderData();
  const activeTab = route.pageTab ?? PageTab.Individual;

  const sessionPermissions = useSelector(getSessionPermissions);
  const permissionsLoadState = useSessionPermissionsLoadState();

  if (!sessionPermissions) return permissionsLoadState;
  if (!sessionPermissions.includesReadAccessToMarketplace) return <NotAuthorized />;

  switch (activeTab) {
    case PageTab.Individual:
      return <IndividualBookmarks activeTab={activeTab} />;
    case PageTab.Team:
      return <TeamBookmarks activeTab={activeTab} />;
    case PageTab.Company:
      return <CompanyBookmarks activeTab={activeTab} />;
    default:
      return <IndividualBookmarks activeTab={activeTab} />;
  }
}
